import Component from "vue-class-component";
import Vue from "Vue";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class Scroll extends Vue {
	@Prop({ default: false })
	private scrollHide;

	@Prop({ default: false })
	private spaceRight;

	@Prop({ default: false })
	private spaceBottom;

	@Prop({ default: false })
	private displayColumn;

	@Prop({ default: 0 })
	private valueSyncHorizontal;

	@Prop({ default: 0 })
	private valueSyncVertical;

	@Prop({ default: false })
	private valueSyncIsSmooth;

	@Prop({ default: false })
	private disableAction;

	private sensibiliy = 0.3;
	private altScroll = false;

	private scrollable;
	private trackVertical;
	private thumbVertical;
	private trackHorizontal;
	private thumbHorizontal;
	private init = false;
	private isOwner = false;

	public calculScroll(): void {
		this.setSizeScrollbar();
		this.listenScrollbar();
	}

	public mounted(): void {
		this.scrollable = <HTMLDivElement> this.$refs.scrollable;
		this.trackVertical = <HTMLDivElement> this.$refs.verticaltrack;
		this.thumbVertical = <HTMLDivElement> this.$refs.verticalthumb;
		this.trackHorizontal = <HTMLDivElement> this.$refs.horizontaltrack;
		this.thumbHorizontal = <HTMLDivElement> this.$refs.horizontalthumb;

		this.listenScrollbar();

		window.addEventListener("resize", () => {
			this.setSizeScrollbar();
			this.listenScrollbar();
		}, true);

		document.addEventListener("keydown", (evt) => {
			if (evt.code === "ShiftLeft") { // SHIFT LEFT
				this.altScroll = true;
			}
		});

		document.addEventListener("keyup", (evt) => {
			if (evt.code === "ShiftLeft") { // SHIFT LEFT
				this.altScroll = false;
			}
		});
	}

	public updated(): void {
		if (!this.init && this.scrollable.offsetHeight !== 0) {
			this.setSizeScrollbar();
			this.init = true;
		}
	}

	public setSizeScrollbar(): void {
		this.$forceUpdate();
		this.scrollable = <HTMLDivElement> this.$refs.scrollable;

		// ------------------ VERTICAL

		const viewableRatioHeight = this.scrollable.offsetHeight / this.scrollable.scrollHeight;
		this.thumbVertical.style.height = (viewableRatioHeight >= 1) ? "100%" : this.scrollable.offsetHeight * viewableRatioHeight + "px";
		this.thumbVertical.style.top = 0 + "px";
		this.scrollable.scrollTop = 0;

		if (viewableRatioHeight >= 1) {
			this.trackVertical.classList.add("full");
		} else {
			this.trackVertical.classList.remove("full");
		}

		// ------------------ HORIZONTAL

		const viewableRatioWidth = this.scrollable.offsetWidth / this.scrollable.scrollWidth;
		this.thumbHorizontal.style.width = (viewableRatioWidth >= 1) ? "100%" : this.scrollable.offsetWidth * viewableRatioWidth + "px";
		this.thumbHorizontal.style.left = 0 + "px";
		this.scrollable.scrollLeft = 0;

		if (viewableRatioWidth >= 1) {
			this.trackHorizontal.classList.add("full");
		} else {
			this.trackHorizontal.classList.remove("full");
		}
	}

	private listenScrollbar(): void {
		if (this.disableAction) {
			return;
		}

		if (this.scrollable.id == "") {
			let positionScrollVertical = 0;
			let positionScrollHorizontal = 0;
			let dragVertical = false;
			let dragHorizontal = false;
			let deltaMouse = 0;
			let positionLeftThumb = 0;
			let positionTopThumb = 0;

			this.scrollable.addEventListener("wheel", (event) => {
				event.preventDefault();
				this.isOwner = true;
				this.sendIsSmooth(true);

				if (this.altScroll) {
					this.thumbHorizontal.classList.add("active");
					positionScrollHorizontal = this.getPositionScrollbarHorizontal(this.scrollable, event, positionScrollHorizontal);
					this.scrollable.scrollTo({ left: positionScrollHorizontal, behavior: "smooth" });
					this.thumbHorizontal.style.left = positionScrollHorizontal * 100 / this.scrollable.scrollWidth + "%";

					this.sendSyncHorizontal(positionScrollHorizontal);

					window.setTimeout(() => {
						this.thumbHorizontal.classList.remove("active");
					}, 300);
				} else {
					this.thumbVertical.classList.add("active");
					positionScrollVertical = this.getPositionScrollbarVertical(this.scrollable, event, positionScrollVertical);
					this.scrollable.scrollTo({ top: positionScrollVertical, behavior: "smooth" });
					this.thumbVertical.style.top = positionScrollVertical * 100 / this.scrollable.scrollHeight + "%";

					this.sendSyncVertical(positionScrollVertical);

					window.setTimeout(() => {
						this.thumbVertical.classList.remove("active");
					}, 300);
				}

				this.isOwner = false;
			});

			this.thumbVertical.addEventListener("mousedown", (event) => {
				this.isOwner = true;
				this.sendIsSmooth(false);

				dragVertical = true;
				deltaMouse = event.clientY;
				this.thumbVertical.classList.add("no-animation");
				positionTopThumb = this.thumbVertical.offsetTop;
			});

			this.thumbHorizontal.addEventListener("mousedown", (event) => {
				this.isOwner = true;
				this.sendIsSmooth(false);

				dragHorizontal = true;
				deltaMouse = event.clientX;
				this.thumbHorizontal.classList.add("no-animation");
				positionLeftThumb = this.thumbHorizontal.offsetLeft;
			});

			window.addEventListener("mouseup", () => {
				dragVertical = false;
				dragHorizontal = false;
				this.thumbVertical.classList.remove("no-animation");
				this.thumbHorizontal.classList.remove("no-animation");
				this.isOwner = false;
			});

			window.addEventListener("mousemove", (event) => {
				if (dragVertical) {
					let positionScroll = event.clientY - deltaMouse;
					positionScroll = positionTopThumb + positionScroll;

					if (positionScroll < 0) {
						positionScroll = 0;
					}
					if (positionScroll > (this.scrollable.offsetHeight - this.thumbVertical.offsetHeight)) {
						positionScroll = this.scrollable.offsetHeight - this.thumbVertical.offsetHeight;
					}

					this.thumbVertical.style.top = positionScroll + "px";
					this.scrollable.scrollTop = positionScroll;

					this.sendSyncVertical(positionScroll);
				}

				if (dragHorizontal) {
					let positionScroll = event.clientX - deltaMouse;
					positionScroll = positionLeftThumb + positionScroll;

					if (positionScroll < 0) {
						positionScroll = 0;
					}
					if (positionScroll > (this.scrollable.offsetWidth - this.thumbHorizontal.offsetWidth)) {
						positionScroll = this.scrollable.offsetWidth - this.thumbHorizontal.offsetWidth;
					}

					this.thumbHorizontal.style.left = positionScroll + "px";
					this.scrollable.scrollLeft = positionScroll;

					this.sendSyncHorizontal(positionScroll);
				}
			});
		}
	}

	private getPositionScrollbarVertical(el, event, scrollTop): number {
		let positionScroll = scrollTop;
		positionScroll += (event.deltaY * this.sensibiliy);

		if (positionScroll < 0) {
			positionScroll = 0;
		}
		if (positionScroll > el.scrollHeight - el.offsetHeight) {
			positionScroll = el.scrollHeight - el.offsetHeight;
		}

		return positionScroll;
	}

	private getPositionScrollbarHorizontal(el, event, scrollLeft): number {
		let positionScroll = scrollLeft;
		positionScroll += (event.deltaY * this.sensibiliy);

		if (positionScroll < 0) {
			positionScroll = 0;
		}
		if (positionScroll > el.scrollWidth - el.offsetWidth) {
			positionScroll = el.scrollWidth - el.offsetWidth;
		}

		return positionScroll;
	}

	private sendSyncHorizontal(positionScrollHorizontal: number): void {
		this.$emit("update:syncHorizontal", positionScrollHorizontal);
	}

	private sendIsSmooth(isSmooth: boolean): void {
		this.$emit("update:isSmooth", isSmooth);
	}

	private sendSyncVertical(positionScrollVertical): void {
		this.$emit("update:syncVertical", positionScrollVertical);
	}

	@Watch("valueSyncHorizontal")
	private listenSyncHorizontal() {
		if (!this.isOwner) {
			if (this.valueSyncIsSmooth) {
				this.scrollable.scrollTo({ left: this.valueSyncHorizontal, behavior: "smooth" });
			} else {
				this.scrollable.scrollLeft = this.valueSyncHorizontal;
			}

			this.thumbHorizontal.style.left = this.valueSyncHorizontal * 100 / this.scrollable.scrollWidth + "%";
		}
	}

	@Watch("valueSyncVertical")
	private listenSyncVertical() {
		if (!this.isOwner) {
			if (this.valueSyncIsSmooth) {
				this.scrollable.scrollTo({ top: this.valueSyncVertical, behavior: "smooth" });
			} else {
				this.scrollable.scrollTop = this.valueSyncVertical;
			}

			this.thumbVertical.style.top = this.valueSyncVertical * 100 / this.scrollable.scrollHeight + "%";
		}
	}

	public setResetScroll(): void {
		this.thumbVertical.style.top = 0 + "px";
		this.scrollable.scrollTop = 0;
		this.thumbHorizontal.style.left = 0 + "px";
		this.scrollable.scrollLeft = 0;
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/Scroll/Scroll.ts